import { apiClient } from '@/lib/apiClient';
import type { CountryOption } from '../types/admin.types';

export const countriesService = {
  getCountries: async (accessToken: string): Promise<CountryOption[]> => {
    return apiClient<CountryOption[]>('/countries', {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
};
